// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.softlite-custom-attribute-control__item{
    padding: 10px 0px;
    margin-bottom: -15px;
}
.softlite-custom-attribute-control__item .components-base-control__field{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.softlite-custom-attribute-control__item .components-base-control__field label{
    margin-bottom: 0;
    font-size: 13px;
    font-weight: 400;
    text-transform: capitalize;
}
.softlite-custom-attribute-control__item .components-base-control__field input{
    width: 70%;
}
.softlite-custom-attribute-control__item .components-base-control{
    margin-bottom: 15px;
}
.softlite-custom-attribute-panel{
    position: relative;
    border: 1px solid #e9e9e9 !important;
}
.softlite-custom-attribute-panel button{
    padding: 10px !important;
    font-weight: 400 !important;
}
.softlite-custom-attribute-panel button:focus{
    outline: none !important;
    box-shadow: none !important;
}
.softlite-custom-attribute-panel.is-opened .components-panel__body-title{
    border-bottom: 1px solid #dedede;
}
.softlite-custom-attribute-panel:not(:last-child){
    margin-bottom: 10px;
}
.softlite-custom-attribute-panel button svg.fa-xmark{
    background: #fb5454;
    color: #fff;
    padding: 1px 2px;
    font-size: 13px;
    position: absolute;
    right: 2px;
    top: 3px;
}`, "",{"version":3,"sources":["webpack://./assets/js/src/controls/custom-attribute/custom-attribute.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;AACA;IACI,UAAU;AACd;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,oCAAoC;AACxC;AACA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;AACA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;AACA;IACI,gCAAgC;AACpC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,QAAQ;AACZ","sourcesContent":[".softlite-custom-attribute-control__item{\r\n    padding: 10px 0px;\r\n    margin-bottom: -15px;\r\n}\r\n.softlite-custom-attribute-control__item .components-base-control__field{\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n.softlite-custom-attribute-control__item .components-base-control__field label{\r\n    margin-bottom: 0;\r\n    font-size: 13px;\r\n    font-weight: 400;\r\n    text-transform: capitalize;\r\n}\r\n.softlite-custom-attribute-control__item .components-base-control__field input{\r\n    width: 70%;\r\n}\r\n.softlite-custom-attribute-control__item .components-base-control{\r\n    margin-bottom: 15px;\r\n}\r\n.softlite-custom-attribute-panel{\r\n    position: relative;\r\n    border: 1px solid #e9e9e9 !important;\r\n}\r\n.softlite-custom-attribute-panel button{\r\n    padding: 10px !important;\r\n    font-weight: 400 !important;\r\n}\r\n.softlite-custom-attribute-panel button:focus{\r\n    outline: none !important;\r\n    box-shadow: none !important;\r\n}\r\n.softlite-custom-attribute-panel.is-opened .components-panel__body-title{\r\n    border-bottom: 1px solid #dedede;\r\n}\r\n.softlite-custom-attribute-panel:not(:last-child){\r\n    margin-bottom: 10px;\r\n}\r\n.softlite-custom-attribute-panel button svg.fa-xmark{\r\n    background: #fb5454;\r\n    color: #fff;\r\n    padding: 1px 2px;\r\n    font-size: 13px;\r\n    position: absolute;\r\n    right: 2px;\r\n    top: 3px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
